export const isFileFormatCorrect = ({
  type,
  allowedTypes,
}: {
  type: string;
  allowedTypes?: readonly string[];
}): boolean => {
  if (!allowedTypes) return true;
  const types = allowedTypes.join('|');
  const regex = new RegExp(types);
  return regex.test(type);
};
